import { Injectable } from '@angular/core';
import { ApiUploadService } from '@app/core/http/api-upload/api-upload.service';
import { LoginAccount } from '@app/shared/models/loginAccount';
import { Capacitor } from '@capacitor/core';
import { FilePicker } from '@whiteguru/capacitor-plugin-file-picker';
import { LocalFile } from '@shared/models/file-types';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
// import { SharedService } from '../shared/shared.service';
import { ToastService } from '../toast/toast.service';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  constructor(
    // private sharedSvc: SharedService,
    private apiUploadSvc: ApiUploadService,
    private androidPermissions: AndroidPermissions,
    private toastService: ToastService
  ) {}

  async getSignedUrl(values: any) {
    return await this.apiUploadSvc.getSignedUrl(values);
  }

  async uploadFile(file: LocalFile, singedUrl: any) {
    const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    };

    const data = b64toBlob(file.content, file.contentType);

    return await this.apiUploadSvc.uploadFile(data, singedUrl);
  }

  async confirmFileUpload(values: any) {
    return await this.apiUploadSvc.confirmFileUpload(values);
  }
  getAccountByName(providerName: string, authProviders: Array<LoginAccount>) {
    return authProviders.find((e) => e.account === providerName);
  }

  async uploadImageFile(isFiles = false) {
    const allowedImageMimeTypes = isFiles
      ? []
      : [
          'image/*',
          // 'image/png',
          // 'image/gif',
          // 'image/webp',
          // 'image/svg+xml',
          // 'image/bmp',
          // 'image/tiff',
          // 'image/x-icon',
          // 'image/vnd.microsoft.icon',
        ];
    if (Capacitor.getPlatform() === 'ios') {
      // return await FilePicker.pickFiles({
      //   types: allowedImageMimeTypes,
      // });
      return await FilePicker.pick({
        mimes: allowedImageMimeTypes,
        multiple: true,
      });
    } else {
      const result = await this.checkFilePickerPermission();
      if (result) {
        return await FilePicker.pick({
          mimes: allowedImageMimeTypes,
          multiple: true,
        });
        // console.log("🚀 ~ UploadService ~ uploadImageFile ~ resp:", resp)
        // return await FilePicker.pickFiles({
        //   types: allowedImageMimeTypes,
        //   // readData: true,
        // });
      } else {
        return null;
      }
    }
  }

  async checkFilePickerPermission(): Promise<boolean> {
    return new Promise(async (resolve, rejects) => {
      const mediaResp = await this.androidPermissions.checkPermission(
        'android.permission.ACCESS_MEDIA_LOCATION'
      );
      if (mediaResp.hasPermission) {
        resolve(true);
      } else {
        const mediaResp = await this.androidPermissions.requestPermission(
          'android.permission.ACCESS_MEDIA_LOCATION'
        );
        await this.androidPermissions.requestPermission(
          'android.permission.READ_EXTERNAL_STORAGE'
        );
        if(!mediaResp.hasPermission) {
          await this.toastService.presentErrorToast('FILE_PICKER_PERMISSION');
        }
        resolve(mediaResp.hasPermission);
      }
    });
  }
}
